import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { get } from '@ally/metronome-ui'
import { AcctDetailsItem, Dd, Dt } from './StyledDlElements'

interface NavLinkDlProps {
  title: string
  definition: string | number
  to: string
  disabled?: boolean
}

// TODO - replace these react-router-dom links with metronome links when query string capability added
const StyledLink = styled(Link)`
  padding: 0;
  margin: 0;
  text-decoration: none;
  color: ${get.colors('bluesuedeshoes')};
`

const StyledDisabledLink = styled.span`
  padding: 0;
  margin: 0;
  cursor: default;
`

export const NavLinkDL: React.FC<NavLinkDlProps> = ({
  title,
  definition,
  to,
  disabled,
}) => {
  return (
    <AcctDetailsItem>
      <Dt>
        {!disabled ? (
          <StyledLink to={to} data-testid="enabled-link">
            {title}
          </StyledLink>
        ) : (
          <StyledDisabledLink data-testid="disabled-link">
            {title}
          </StyledDisabledLink>
        )}
      </Dt>
      <Dd>{definition}</Dd>
    </AcctDetailsItem>
  )
}
